@use 'src/styles/variables-bundle' as *;

:host {
  --num-slides: 3.5;

  visibility: hidden;
  opacity: 0;
  position: relative;
  overflow-y: clip;

  @include S_and_up {
    --num-slides: 4.5;
  }

  @include M_and_up {
    --num-slides: 5.5;
  }

  @include L_and_up {
    --num-slides: 6.5;
  }

  @include XL_and_up {
    --num-slides: 7.5;
  }
}
